var React = require('react');

function ScopeInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M31 17C31 24.732 24.732 31 17 31M31 17C31 9.26801 24.732 3 17 3M31 17H29M31 17H33M17 31C9.31814 31 3 24.6819 3 17M17 31C17 29.4379 17 29 17 29M17 31V33M3 17C3 9.26801 9.26801 3 17 3M3 17H5M3 17H1M17 3V5M17 3V1","stroke":"#697380","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("circle",{"cx":"17.0011","cy":"17.0001","r":"4.57143","stroke":"#697380","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round","key":1})]);
}

ScopeInline.defaultProps = {"width":"34","height":"34","viewBox":"0 0 34 34","fill":"none"};

module.exports = ScopeInline;

ScopeInline.default = ScopeInline;
